// extracted by mini-css-extract-plugin
export default {"main_div":"FormModal_main_div__mxvSO","error_msg":"FormModal_error_msg__c6tIP"};